import { config } from "../config/env";
import { ApiOptions } from "../types/interface.types";

import axios, { AxiosRequestConfig } from "axios";

const baseURL = config.LOTUS_RECOMMENDATION_ENDPOINT;

export async function apiRequest<T = unknown>(
  url: string,
  options: ApiOptions,
): Promise<T> {
  const configs: AxiosRequestConfig = {
    url: `${baseURL}${url}`,
    method: options.method ?? "GET",
    withCredentials: true,
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(options.accessToken
        ? { Authorization: `Bearer ${options.accessToken}` }
        : {}),
    },
    params: options.params ?? undefined,
    data: options.body ?? undefined,
  };
  try {
    const response = await axios.request(configs);

    return response.data as T;
  } catch {
    return null as T;
  }
}
